import { MainFeature, UserLimit } from '../types';

export const PLAN_LIMITS: Record<MainFeature, UserLimit> = {
  light: { admin: 2, supervisor: 4, viewer: 2 },
  basic: { admin: 2, supervisor: 5, viewer: 10 },
  standard: { admin: 2, supervisor: 5, viewer: 10 },
  premium: { admin: 2, supervisor: 50, viewer: 50 },
  four_s: { admin: 2, supervisor: 50, viewer: 50 },
};
